// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import Block from "components/layout/Block";

// #####################################################

const StyledPaginationBullet = styled.span`
	display: inline-block;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	margin: 0 6px;
	cursor: pointer;
	background: #a9a9a9;

	opacity: 0.4;
	transform: scale(${({ $scale }) => $scale});
	transition: 400ms transform;

	${({ $isActive, $isDarkMode, $multiColor }) => {
		if ($multiColor) {
			return $isActive && $isDarkMode
				? css`
						background: var(--color-whiteTrueAlways-darken-200);
						opacity: 1;
				  `
				: $isActive &&
						css`
							background: var(--color-primary-always);
							opacity: 1;
						`;
		} else {
			return (
				$isActive &&
				css`
					background: var(--color-whiteTrueAlways-darken-200);
					opacity: 1;
				`
			);
		}
	}}
`;

// #####################################################

const SliderPagination = ({
	totalSlides,
	activeSlide,
	onPaginationClick,
	multiColor = false,
}) => {
	const isDarkMode = useSelector(
		(state) => state.globalCommon?.darkMode?.isDarkMode
	);
	let visibleBullets = 5;

	// Jeśli jesteśmy na pierwszej, drugiej, przedostatniej lub ostatniej pozycji, dostosowujemy widoczne kropki
	if (activeSlide === 0 || activeSlide === totalSlides - 1) {
		visibleBullets = 3;
	} else if (activeSlide === 1 || activeSlide === totalSlides - 2) {
		visibleBullets = 4;
	}

	const paginationItems = [];
	const midIndex = Math.floor(visibleBullets / 2);

	// Obliczanie startowego indeksu kropek
	let start = Math.max(
		0,
		Math.min(activeSlide - midIndex, totalSlides - visibleBullets)
	);
	let end = Math.min(start + visibleBullets, totalSlides);

	// Funkcja obliczająca skalę kropki w zależności od jej położenia względem aktywnej
	const getBulletScale = (index) => {
		const distanceFromActive = Math.abs(activeSlide - index);

		if (distanceFromActive === 0) return 1; // Największa kropka dla aktywnego
		if (distanceFromActive === 1) return 0.7; // Średnie kropki obok aktywnego
		if (distanceFromActive === 2) return 0.4; // Mniejsze kropki dalej od aktywnego
		return 0.5; // Najmniejsze kropki na końcach
	};

	// Generowanie widocznych kropek
	for (let i = start; i < end; i++) {
		const scale = getBulletScale(i); // Rozmiar kropki zależy od jej pozycji
		paginationItems.push(
			<StyledPaginationBullet
				key={i}
				onClick={() => onPaginationClick(i)}
				$isActive={i === activeSlide}
				$scale={scale}
				$isDarkMode={isDarkMode}
				$multiColor={multiColor}
			/>
		);
	}

	// #####################################################

	return (
		<Block flex justifyCenter alignCenter>
			{paginationItems}
		</Block>
	);
};

// #####################################################

export default SliderPagination;
